// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__11R48","approved":"Status_approved__3uNP7","rejected":"Status_rejected__32lB3","expired":"Status_expired__izZ5-","label":"Status_label__1qpHt"};